export default "__VITE_ASSET__22537db3__"